var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_598_14004)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.34619 12.5713L10.4231 7.32129L12.5 12.5713M8.9396 11.0713H11.9066",
  stroke: "black",
  strokeOpacity: 0.85,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 4.47104H9M6 3.57104V4.47104M7.85807 4.47104C7.85807 4.47104 7.675 6.40698 6.46667 8.07104C5.25833 9.73511 3.86667 10.771 3.86667 10.771M7.33333 9.87104C7.33333 9.87104 6.37083 9.19604 5.6 8.07104C4.82917 6.94604 4.73333 6.27104 4.73333 6.27104",
  stroke: "black",
  strokeOpacity: 0.85,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.9 15.071H10.1C13.6 15.071 15 13.671 15 10.171V5.97105C15 2.47105 13.6 1.07104 10.1 1.07104H5.9C2.4 1.07104 1 2.47105 1 5.97105V10.171C1 13.671 2.4 15.071 5.9 15.071Z",
  stroke: "black",
  strokeOpacity: 0.85,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_598_14004"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0 0.0710449)"
})));

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.08478c15e72a7e1b615197d7616f2a7f.svg";
export { ForwardRef as ReactComponent };